
export const parsePoiAdvantages = (poi, strings) => {
    return [
        poi.cat_convenzioni === '1' ? strings.club_benefits : false,
        poi.cat_areesosta === '1' ? strings.parking_areas : false,
        poi.cat_areeservizio === '1' ? strings.service_areas : false,
        poi.cat_camping === '1' ? strings.campsites : false,
        poi.cat_attrazioni === '1' ? strings.attractions : false,
        poi.cat_allianz === '1' ? strings.allianz : false
    ].filter(cat => cat).join(', ');
};

export const parsePoiAddress = (poi) => [poi.citta_poi, poi.indirizzo_poi].filter(field => Boolean(field)).join(', ');

export const parseTrendingPoiAdvantages = (poi, strings) => {
    return [
        poi.CON === '1' ? strings.club_benefits : false,
        poi.SOS === '1' ? strings.parking_areas : false,
        poi.SER === '1' ? strings.service_areas : false,
        poi.CAM === '1' ? strings.campsites : false,
        poi.ATT === '1' ? strings.attractions : false,
    ].filter(cat => cat).join(', ')
};

export const parseTrendingPoiAddress = (poi) => [poi.citta_poi].filter(field => Boolean(field)).join(', ');
